import React from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import ClientSecurities from './ClientSecurities';
import ClientAccounts from './ClientAccounts';
import ClientReconciliations from './ClientReconciliations';
import ClientDocuments from './ClientDocuments';
import classnames from 'classnames';

class ClientReportTabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 1,
        };

    }

    render = () => {
        this.props.info('ClientReportTabs.js/render');
        return (
            <tr className="activeTab my-0">
                <td colSpan="6" className="text-left">
                    <Nav tabs className="px-0">
                        <NavItem >
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 1 })}
                                onClick={() => { this.setState({ activeTab: 1 }); this.props.changeTab(); }}>
                                New Securities
                            </NavLink>
                        </NavItem>
                        <NavItem >
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 2 })}
                                onClick={() => { this.setState({ activeTab: 2 }); this.props.changeTab(); }}>
                                New Accounts
                            </NavLink>
                        </NavItem>
                        <NavItem >
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 3 })}
                                onClick={() => { this.setState({ activeTab: 3 }); this.props.changeTab(); }}>
                                Reconciliation Status
                            </NavLink>
                        </NavItem>
                        <NavItem >
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 4 })}
                                onClick={() => { this.setState({ activeTab: 4 }); this.props.changeTab(); }}>
                                Documents
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab} className="px-5 py-3 mx-0 mb-3 border-left border-right border-bottom activeInsideTab">
                        <TabPane tabId={1}>
                            <ClientSecurities {...this.props} report={this.props.report} />
                        </TabPane>
                        <TabPane tabId={2}>
                            <ClientAccounts {...this.props} report={this.props.report} />
                        </TabPane>
                        <TabPane tabId={3}>
                            <ClientReconciliations {...this.props} />
                        </TabPane>
                        <TabPane tabId={4}>
                            <ClientDocuments {...this.props} />
                        </TabPane>
                    </TabContent>
                </td></tr>
        )
    }
}

export default ClientReportTabs;